import React from 'react';
import { Link, Redirect } from 'react-router-dom';

import { approvePaymentArrangement, setPurchaseOverdue } from 'api';
import { transformErrorResponse } from 'helpers/errors';
import FormError from '../FormError';

const approveStatus = 'arranged';
const denyStatus = 'denied_arrangement';

export default class GenerateRenewalInvoiceButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: undefined,
      success: false,
    };
  }

  async approve(approvalStatus) {
    try {
      const { purchaseId, findPurchase } = this.props;
      const { status } = await approvePaymentArrangement(
        purchaseId,
        approvalStatus,
      );
      if (status === 200 || status === 201) {
        await findPurchase(purchaseId);
        this.setState({ success: approvalStatus });
      }
    } catch ({ response }) {
      const error = transformErrorResponse(response.data);
      this.setState({
        error,
      });
    }
  }

  async setOverdue(purchaseId, approvalStatus) {
    try {
      const { status } = await setPurchaseOverdue(purchaseId);

      if (status === 200 || status === 201) {
        this.setState({
          success: approvalStatus,
        });
      }
    } catch ({ response }) {
      const error = transformErrorResponse(response.data);
      this.setState({
        error,
      });
    }
  }

  render() {
    const { user, purchaseId } = this.props;
    const { error, success } = this.state;

    if (success) {
      const alertType = success === approveStatus ? 'success' : 'danger';
      const alertMessage =
        success === approveStatus
          ? 'The arrangement has been approved'
          : 'The arrangement has been denied';
      return (
        <Redirect
          to={`/purchases/${purchaseId}/view?message=${alertMessage}&type=${alertType}`}
        />
      );
    }

    return (
      <div className="alert alert-warning">
        <h4>Pending Payment Arrangement Approval</h4>
        <table className="table">
          <tr>
            <td>ID</td>
            <td>Email</td>
            <td colSpan={4}>Name</td>
          </tr>
          <tr>
            <td>{user.id}</td>
            <td>{user.email}</td>
            <td>
              {user.first_name} {user.last_name}
            </td>
            <td>
              <Link to={`/users/${user.id}/purchases`} target="_blank">
                View All Purchases
              </Link>
            </td>
            <td>
              <button
                className="btn btn-success"
                onClick={() => this.approve(approveStatus)}
              >
                Approve
              </button>
            </td>
            <td>
              <button
                className="btn btn-danger"
                onClick={() => this.approve(denyStatus)}
              >
                Deny
              </button>
            </td>
          </tr>
        </table>
        {error ? <FormError error={error} /> : null}
      </div>
    );
  }
}
